import { render, staticRenderFns } from "./MainSliderNew.vue?vue&type=template&id=4d77a5a9&scoped=true"
import script from "./MainSliderNew.vue?vue&type=script&lang=js"
export * from "./MainSliderNew.vue?vue&type=script&lang=js"
import style0 from "./MainSliderNew.vue?vue&type=style&index=0&id=4d77a5a9&prod&lang=scss&scoped=true"
import style1 from "./MainSliderNew.vue?vue&type=style&index=1&id=4d77a5a9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d77a5a9",
  null
  
)

export default component.exports